module.exports = __webpack_public_path__ + "img/ic_keyboard_normal.8c02ef77.svg";